<template>
  <component :is="dashboardComponent" />
</template>

<script>
import {useUserStore} from "@/stores/user";
import Dashboard from "@/pages/Dashboard.vue";
import StaffDashboard from "@/pages/StaffDashboard.vue";

export default {
  name: "DashboardEntry",
  components: {
    Dashboard,
    StaffDashboard,
  },
  setup() {
    return {
      userStore: useUserStore(),
    }
  },
  computed: {
    dashboardComponent() {
      if (this.userStore.user?.isStaffMember?.() && !this.userStore.user?.currentOrganisationPresent?.()) {
        return 'StaffDashboard'
      }

      return 'Dashboard'
    }
  }
}
</script>
